export const VARIABLES_TYPES = {
  ADD: 'ADD',
  CHANGE: 'CHANGE',
};
